import React from "react";
import "./services.css";

export default function ServiceCard({ icon, title, text, index = 0 }) {
  return (
    <article className="service-card">
      <div className="service-card__top">
        <span className="service-card__icon" aria-hidden="true"><i className={icon} /></span>
        <span className="service-card__number">{String(index + 1).padStart(2, "0")}</span>
      </div>
      <h3 className="service-card__title">{title}</h3>
      <p className="service-card__text">{text}</p>
      <span className="service-card__rule" aria-hidden="true" />
    </article>
  );
}
